import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { SchedulerCoreModule } from '@radioking/scheduler-core';
import { UiButtonModule } from '@radioking/ui/button';
import { UiDatepickerModule } from '@radioking/ui/datepicker';
import { UiInputModule } from '@radioking/ui/input';
import { UiPageTitleModule } from '@radioking/ui/page-title';
import { UiPlaylistIconModule } from '@radioking/ui/playlist-icon';
import { UiQuestionMarkModule } from '@radioking/ui/question-mark';
import { UiTooltipModule } from '@radioking/ui/tooltip';
import { UiTrackInputWithSuggestionsModule } from '@radioking/ui/track-input-with-suggestions';
import { UiWeekdaySelectModule } from '@radioking/ui/weekday-select';
import { MobileCalendarHeaderComponent } from 'libs/ui/mobile-calendar-header/mobile-calendar-header.component';

import { ProgramsState } from '../../../programs/src/lib/states/programs.state';
import { SchedulerCoreState } from '../../../scheduler-core/src/lib/states/scheduler-core.state';
import { BigTimeFormatLettersPipe } from '../../../shared/pipes/big-time-format-letters.pipe';
import { BreakDeletionComponent } from './components/break-deletion/break-deletion.component';
import { BreakEditionComponent } from './components/break-edition/break-edition.component';
import { BreakHeaderComponent } from './components/break-header/break-header.component';
import { BreakListComponent } from './components/break-list/break-list.component';
import { BreakPopoverComponent } from './components/break-popover/break-popover.component';
import { BreakShellComponent } from './components/break-shell/break-shell.component';

import { MatStepperModule } from '@angular/material/stepper';
import { UiMobileFabButtonModule } from '@radioking/ui/mobile-fab-button';
import { DirectivesModule } from 'libs/directives/directives.module';
import { UiMobileCloseButtonModule } from 'libs/ui/mobile-close-button/src/lib/ui-mobile-close-button.module';
import { BreakState } from './states/break.state';

const routes: Route[] = [
  {
    path: 'breaks',
    component: BreakShellComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxsModule.forFeature([BreakState, SchedulerCoreState, ProgramsState]),
    TranslateModule,
    FullCalendarModule,
    UiButtonModule,
    MatDialogModule,
    UiDatepickerModule,
    UiInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatCheckboxModule,
    SharedModule,
    MatSlideToggleModule,
    UiTrackInputWithSuggestionsModule,
    UiPlaylistIconModule,
    MatButtonToggleModule,
    UiTooltipModule,
    MatMenuModule,
    UiPageTitleModule,
    UiWeekdaySelectModule,
    SchedulerCoreModule,
    UiQuestionMarkModule,
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    MobileCalendarHeaderComponent,
    UiMobileFabButtonModule,
    UiMobileCloseButtonModule,
    MatStepperModule,
    DirectivesModule,
  ],
  providers: [BigTimeFormatLettersPipe],
  declarations: [
    BreakHeaderComponent,
    BreakEditionComponent,
    BreakPopoverComponent,
    BreakDeletionComponent,
    BreakShellComponent,
    BreakListComponent,
  ],
})
export class BreakModule {}
